import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { Field } from '../../../features/form';
import { hasDeliveryInfo, changeHasDeliveryInfo } from '../../../features/commerce';
import { FormWrap, FieldComponent, FormIcon } from './FieldForms';
import { Paragraph, Span } from '../../../components/typography';
import { Div } from '../../../components/grid';
import ExtraPhonenumbersField from './FieldForms/ExtraPhonenumbersField';
import { BsCheckSquare, BsSquare } from '../../../components/Icons';

const ByGrid = styled(Div)`
  display: grid;
  grid-template-columns: 130px 1fr;
  grid-gap: 10px;
`;

const LeveringForm = () => (
  <FormWrap>
    <Paragraph bold>
      Leveringsadresse:
    </Paragraph>
    <Field
      component={FieldComponent}
      icon={<FormIcon user />}
      name="name"
      formKey="delivery"
      type="text"
      placeholder="Navn på leveringssted"
    />
    <Field
      component={FieldComponent}
      icon={<FormIcon userAlt />}
      name="attName"
      formKey="delivery"
      type="text"
      placeholder="Evt. Navn på modtager"
    />
    <Field
      component={FieldComponent}
      icon={<FormIcon home />}
      name="address"
      formKey="delivery"
      type="text"
      placeholder="Adresse"
    />
    <ByGrid>
      <Field
        component={FieldComponent}
        icon={<FormIcon city />}
        name="zipCode"
        formKey="delivery"
        type="text"
        placeholder="Postnr."
        postnr
      />
      <Field
        component={FieldComponent}
        name="city"
        formKey="delivery"
        type="text"
        placeholder="By"
        by
      />
    </ByGrid>
    <Field
      component={FieldComponent}
      icon={<FormIcon phone />}
      name="phonenumber"
      formKey="delivery"
      type="text"
      placeholder="Evt. modtagers tlf nr"
    />
    <Field
      component={ExtraPhonenumbersField}
      name="extraPhonenumbers"
      formKey="delivery"
    />
  </FormWrap>
);
const CheckBoxComponentNoStyle = ({
  checked,
  onClick,
  children,
  ...otherProps
}) => (
  <Div
    onClick={onClick}
    {...otherProps}
  >
    <div className='icon'>{checked ? <BsCheckSquare /> : <BsSquare />}</div>
    <div>{children}</div>
  </Div>
);
const CheckBoxComponent = styled(CheckBoxComponentNoStyle)`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  position: relative;
  font-size: 35px;
  font-weight: 600;
  cursor: pointer;

  & > .icon {
    position: relative;
    top: 3px;
  }

  ${({ checked, theme }) => {
    if (checked) {
      return `
        color: ${theme.colors.colorGreen};
      `;
    }
    return `
      color: ${theme.colors.colorGreyDark};
    `;
  }}
`;

const ChooseLeveringForm = ({ checked, onChange }) => (
  <Div>
    <Div padding="15px 0">
      <CheckBoxComponent checked={checked} onClick={() => onChange(!checked)}>
        <Paragraph bold marginBottom="0">Tilføj leveringsadresse</Paragraph>
        <Span fontSize="12px" block>(Hvis forskellig fra faktureringsadresse)</Span>
      </CheckBoxComponent>
    </Div>
    {checked && <LeveringForm />}
  </Div>
);

export default connect(
  state => ({
    checked: hasDeliveryInfo(state),
  }),
  dispatch => ({
    onChange: setHasDeliveryInfo => dispatch(changeHasDeliveryInfo(setHasDeliveryInfo)),
  }),
)(ChooseLeveringForm);
